<template>
  <div class="main">
    <div class="head">
      <div class="nav">
        <ul>
          <li>
            <a href="javascript:;" @click="category('')" :class="{ choose: isChoose == 0 }">
              すべて (
              <strong>{{
                allTotal.num1Total +
                allTotal.num2Total +
                allTotal.num3Total +
                allTotal.num4Total
              }}</strong>
              )
            </a>
            <span>|</span>
          </li>
          <li>
            <a href="javascript:;" @click="category(1)" :class="{ choose: isChoose == 1 }">
              配送待ち (
              <strong>{{ allTotal.num1Total }}</strong>
              )
            </a>
            <span>|</span>
          </li>
          <li>
            <a href="javascript:;" @click="category(2)" :class="{ choose: isChoose == 2 }">
              配送中 (
              <strong>{{ allTotal.num2Total }}</strong>
              )
            </a>
            <span>|</span>
          </li>
          <li>
            <a href="javascript:;" @click="category(3)" :class="{ choose: isChoose == 3 }">
              オプション作業中 (
              <strong>{{ allTotal.num3Total }}</strong>
              )
            </a>
            <span>|</span>
          </li>
          <li>
            <a href="javascript:;" @click="category(4)" :class="{ choose: isChoose == 4 }">
              注文書番号 (
              <strong>{{ allTotal.num4Total }}</strong>
              )
            </a>
          </li>
        </ul>
        <div class="search fr">
          <input type="text" v-model="list.ordno" placeholder="注文書番号" keydown.enter="getLogisticsList" />
          <button @click="getLogisticsList">確定</button>
        </div>
      </div>
    </div>
    <div class="table title">
      <ol>
        <li>NO</li>
        <li>写真</li>
        <li>サイズ</li>
        <li>カラー</li>
        <li>数量</li>
        <li>単価</li>
        <li>小計</li>
        <li>国内送料</li>
        <li>備考欄</li>
        <li>状態</li>
      </ol>
    </div>
    <div v-if="lists != false">
      <div class="table body" v-for="(item, index) in lists" :key="index">
        <div class="show">
          注文NO：
          <router-link :to="'/zhuwen?ordno=' + item.ordno" target="_blank" style="color: #b7040b">{{ item.ordno
          }}</router-link>-
          {{ item.realname }}
        </div>

        <ul class="listItem" v-for="itemGoods in item.goods" :key="itemGoods.id">
          <li>{{ itemGoods.rownum }}</li>
          <li class="img">
            <router-link :to="itemGoods.type == 'rakumart'
              ? '/details?id=' + itemGoods.iid
              : `/details1688?iid=${itemGoods.iid}&type=${itemGoods.type}${itemGoods.mi_id ? '&mi_id=' + itemGoods.mi_id : ''}`
              " target="_blank">
              <el-popover placement="right" width="400" trigger="hover">
                <img :src="itemGoods.pic" alt="" style="width: 400px" />
                <img :src="itemGoods.pic" alt="" slot="reference" />
              </el-popover>
            </router-link>
          </li>
          <li :title="itemGoods.color">
            <div class="div">{{ itemGoods.color }}</div>
          </li>
          <li :title="itemGoods.psize">
            <div class="div">{{ itemGoods.psize }}</div>
          </li>
          <li>{{ itemGoods.rakusatu }}</li>
          <li>{{ itemGoods.price }}</li>
          <li>{{ (itemGoods.rakusatu * itemGoods.price).toFixed(2) }}</li>
          <li>{{ itemGoods.gnsong }}</li>
          <li class="beikao">
            <el-popover placement="top-start" title="備考欄" width="200" trigger="hover" :content="item.bei">
              <img src="../../../assets/img/note.png" alt="" slot="reference" />
            </el-popover>
          </li>
          <li>
            <router-link :to="'/deliveryStatus?trade=' +
              itemGoods.trade_no +
              '&id=' +
              itemGoods.id
              " target="_blank">
              {{ itemGoods.zt }}</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="tishi body" v-else>何も入っていません</div>
  </div>
</template>
<script>
import { getLogisticsList } from "../../../api/API/DomesticLogistics";
import { tabDataCount } from "../../../api/API/user";
export default {
  data() {
    return {
      show: false,
      isChoose: "",
      list: {
        state: "",
        ordno: "",
        token: localStorage.getItem("token"),
      },
      lists: null,
      allTotal: {},
    };
  },
  created() {
    if (this.$route.query.state != undefined) {
      this.list.state = this.$route.query.state;
      this.isChoose = this.$route.query.state;
    }
    this.getLogisticsList();
    this.tabDataCount();
  },
  methods: {
    tabDataCount() {
      let list = {
        mod: "inc",
        act: "ordersys",
        str: "tabDataCount",
        token: localStorage.getItem("token"),
      };
      tabDataCount(list).then((res) => {
        this.allTotal = res.data.logisticTabData;
      });
    },
    // 各种状态筛选
    category(index) {
      this.isChoose = index;
      this.list.state = index;
      this.getLogisticsList();
    },
    // 获取订单
    getLogisticsList() {
      getLogisticsList(this.list).then((res) => {
        this.lists = res.data.list;
        console.log(res);
        this.lists.forEach((item) => {
          item.show = false;
        });
      });
    },
    itemisshow(i) {
      this.lists[i].show = !this.lists[i].show;
      this.$forceUpdate(); // 强制重绘数据
    },
  },
};
</script>
<style lang='scss' scoped>
.main {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 50px;
  padding: 30px 40px;

  .head {
    height: 44px;
    line-height: 40px;
    overflow: hidden;
    padding-bottom: 14px;
    border-bottom: 1px solid #e9e9e9;
    margin-bottom: 30px;

    ul {
      float: left;

      li {
        height: 40px;
        float: left;
        margin: 0 10px;
        color: #333;

        a {
          display: inline-block;
          height: 40px;
          color: #333;

          strong {
            color: #b7040b;
          }
        }

        .choose {
          color: #b7040b;
        }

        span {
          margin-left: 10px;
        }
      }
    }

    .search {
      position: relative;

      input {
        width: 180px;
        height: 32px;
        border-radius: 2px;
        border: 1px solid #dcdfe6;
        padding-left: 15px;
      }

      button {
        background: #f3c622;
        margin-left: 20px;
        color: #fff;
        padding: 0;
        border-radius: 3px;
        font-size: 14px;
        width: 80px;
        height: 32px;
        background: #f3c622;
        border-radius: 2px;
        text-align: center;
        line-height: 32px;
        color: #222;
        cursor: pointer;
      }
    }
  }

  .table {

    ol,
    ul {
      display: flex;

      li {
        flex: 1;
        text-align: center;
      }
    }

    ol {
      height: 52px;
      background: #f5f5f5;

      border-top: 0;
      line-height: 52px;
      font-weight: 600;
    }
  }

  .body {
    border: 1px solid #e9e9e9;
    margin-top: 30px;

    .flex3 {
      flex: 3;
    }

    ul {
      font-size: 14px;
    }

    .show {
      height: 52px;
      background: #fef9e9;
      line-height: 52px;
      padding-left: 30px;
      font-size: 14px;
    }

    .listItem {
      background-color: #fff;
      height: 60px;
      line-height: 60px;

      li {
        display: flex;
        justify-content: center;
        align-items: center;

        .div {
          overflow: hidden;
          height: 100%;
        }
      }

      .img {
        position: relative;

        a {
          margin-top: 25px;
        }

        img {
          width: 40px;
          height: 40px;
        }

        &:hover .bigImg {
          display: block;
        }

        .bigImg {
          display: none;
          position: absolute;
          top: -200px;
          left: 80px;
          z-index: 99;

          img {
            width: 350px;
            height: 400px;
          }
        }
      }

      .beikao {
        img {
          margin-top: 25px;
          cursor: pointer;
        }
      }

      a {
        color: #b7040b;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .tishi {
    text-align: center;
    padding: 20px 0;
  }
}
</style>
